import React, { Component } from 'react';
import { Tabs, Tab, Popover, OverlayTrigger, PanelGroup, Panel } from 'react-bootstrap';
import { map, filter, size, find, each } from 'lodash';
import CustomScroll from 'react-custom-scroll';
import ServiceTabs from './ServiceTabs';
import { imageBasePath } from '../../constants/staticData';

export default class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popoverDesc: {
        name: "",
        desc: "",
        subCategory: []
      },
      activeCarWash: 0,
      activeCarRepair: 0,
      activeCarService: 0,
      popoverPosition: "right",
      collpaseActive: true
    };
    this.renderCarWash = this.renderCarWash.bind(this);
    this.renderCarRepair = this.renderCarRepair.bind(this);
    this.renderCarService = this.renderCarService.bind(this);
    this.renderSupportedManufacturers = this.renderSupportedManufacturers.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1100) {
      this.setState({ popoverPosition: "bottom" });
    } else {
      this.setState({ popoverPosition: "right" });
    }
  }


  customPopoverRight() {
    let carRepairSubCategory = map(this.state.popoverDesc.subCategory, (subCategory) => {
      let servicePrice = find(this.state.popoverDesc.allGarageServices, { 'serviceId': subCategory.serviceId ? subCategory.serviceId : subCategory.id });
      return (
        <li>
          <span>{subCategory.name}</span>
          <span>{servicePrice && servicePrice.costSedan ? servicePrice.costSedan + " AED" : '-'}</span>
          <span>{servicePrice && servicePrice.costSuvs ? servicePrice.costSuvs + " AED" : '-'}</span>
        </li>
      );
    });
    return (
      <Popover className="customPopover" id={`popover-positioned-${this.state.popoverPosition}`}>
        <h4>{this.state.popoverDesc.name}</h4>
        <p>{this.state.popoverDesc.desc}</p>
        <ul className="popoverPriceList-heading">
          <li>Sub Categories</li>
          <li>Sedan</li>
          <li>SUV</li>
        </ul>
        <ul className="popoverPriceList">
          {carRepairSubCategory}
        </ul>
      </Popover>
    );
  }

  customPopoverWash() {
    return (
      <Popover className="customPopover wash" id={`popover-positioned-${this.state.popoverPosition}`}>
        <h4>{this.state.popoverDesc.name}</h4>
        <p>{this.state.popoverDesc.desc}</p>
        <ul className="popoverPriceList-heading">
          <li>Sedan</li>
          <li>SUV</li>
        </ul>
        <ul className="popoverPriceList">
          <li>
            <span>{this.state.popoverDesc.servicePrice && this.state.popoverDesc.servicePrice.costSedan ? this.state.popoverDesc.servicePrice.costSedan + " AED" : '-'}</span>
            <span>{this.state.popoverDesc.servicePrice && this.state.popoverDesc.servicePrice.costSuvs ? this.state.popoverDesc.servicePrice.costSuvs + " AED" : '-'}</span>
          </li>
        </ul>
      </Popover>
    );
  }

  renderCarWash() {
    let allServices = this.props.garageServices;
    let allGarageServices = this.props.vendorProfileReducer && this.props.vendorProfileReducer.allGarageServices;
    let carWash = filter(allServices, function (service) {
      return service.serviceParentId == 1;
    });
    const carWashListView = allGarageServices && map(carWash, (carItem, key) => {
      let servicePrice = find(allGarageServices, { 'serviceId': carItem.serviceId });
      return (
        <OverlayTrigger key={key} trigger="click" rootClose placement={this.state.popoverPosition} overlay={this.customPopoverWash()}>
          <div className="carModelList" onClick={() => { this.setState({ 'activeCarWash': carItem.id, popoverDesc: { name: carItem.name, desc: carItem.description, servicePrice: servicePrice } }); }}>
            <div className={carItem.id == this.state.activeCarWash ? 'img-circle active' : 'img-circle'}>
              <img src={carItem.image ? carItem.image : `${imageBasePath}/placeholder.png`} alt="" />
            </div>
            <h6>{carItem.name}</h6>
          </div>
        </OverlayTrigger>
      );
    });
    return (
      <div className="vendor-service-container">
        <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
          <div className="vendor-service-list">
            {size(carWashListView)
              ?
              carWashListView :
              <div className="noResults-found">
                <img src={`${imageBasePath}/empty_service.png`} />
                <p>Oops! We couldn’t find what you were looking for</p>
              </div>}
          </div>
        </CustomScroll>
      </div>
    );
  }

  renderCarRepair() {
    let repairRequests = this.props.vendorProfileReducer.getAllServices && find(this.props.vendorProfileReducer.getAllServices, { id: 3 });
    let subServices = this.props.vendorProfileReducer.getAllServices && repairRequests ? repairRequests.sub_services : [];
    let carRepairListView = [];
    let allGarageServices = this.props.vendorProfileReducer && this.props.vendorProfileReducer.allGarageServices;
    allGarageServices && each(subServices, (carItem, key) => {
      let selectedServices = this.props.garageServices;
      let subCategory = filter(selectedServices, { serviceParentId: carItem.id });
      if (subCategory && subCategory.length) {
        carRepairListView.push(
          <OverlayTrigger key={key} trigger="click" rootClose placement={this.state.popoverPosition} overlay={this.customPopoverRight()}>
            <div className="carModelList" onClick={() => { this.setState({ 'activeCarRepair': carItem.id, popoverDesc: { name: carItem.name, desc: carItem.description, subCategory: subCategory, allGarageServices: allGarageServices } }); }}>
              <div className={carItem.id == this.state.activeCarRepair ? 'img-circle active' : 'img-circle'}>
                <img src={carItem.image ? carItem.image : `${imageBasePath}/placeholder.png`} alt="" />
              </div>
              <h6>{carItem.name}</h6>
            </div>
          </OverlayTrigger>
        );
      }
    });
    return (
      <div className="vendor-service-container">
        <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
          <div className="vendor-service-list">
            {size(carRepairListView)
              ?
              carRepairListView :
              <div className="noResults-found">
                <img src={`${imageBasePath}/empty_service.png`} />
                <p>Oops! We couldn’t find what you were looking for</p>
              </div>}
          </div>
        </CustomScroll>
      </div>
    );
  }
  renderCarService() {
    let serviceRequests = this.props.vendorProfileReducer.getAllServices && find(this.props.vendorProfileReducer.getAllServices, { id: 2 });
    let allGarageServices = this.props.vendorProfileReducer && this.props.vendorProfileReducer.allGarageServices;
    return (
      <div className="vendor-service-container">
        <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
          <div className="vendor-service-list">
            {serviceRequests
              ?
              <OverlayTrigger trigger="click" rootClose placement={this.state.popoverPosition} overlay={this.customPopoverRight()}>
                <div className="carModelList" onClick={() => { this.setState({ 'activeCarService': serviceRequests.id, popoverDesc: { name: serviceRequests.name, desc: serviceRequests.description, subCategory: serviceRequests.sub_services, allGarageServices: allGarageServices } }); }}>
                  <div className={serviceRequests.id == this.state.activeCarService ? 'img-circle active' : 'img-circle'}>
                    <img src={`${imageBasePath}/carservice.png`} alt="" />
                  </div>
                  <h6>{serviceRequests.name}</h6>
                </div>
              </OverlayTrigger>
              :
              <div className="noResults-found">
                <img src={`${imageBasePath}/empty_service.png`} />
                <p>Oops! We couldn’t find what you were looking for</p>
              </div>}
          </div>
        </CustomScroll>
      </div>
    );
  }

  renderSupportedManufacturers() {
    const carManufacturersListView = map(this.props.garageManufacturers, (carItem, key) => {
      return (
        <div className="carModelList" key={key}>
          <div className="img-circle">
            <img src={carItem.photos ? carItem.photos : `${imageBasePath}/placeholder.png`} alt="" />
          </div>
          <h6>{carItem.name}</h6>
        </div>
      );
    });
    return (
      <div className="vendor-service-container">
        <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
          <div className="vendor-service-list">
            {size(carManufacturersListView)
              ?
              carManufacturersListView :
              <div className="noResults-found">
                <img src={`${imageBasePath}/empty_service.png`} />
                <p>Oops! We couldn’t find what you were looking for</p>
              </div>}
          </div>
        </CustomScroll>
      </div>
    );
  }
  renderEmergency() {
    let allServices = this.props.garageServices;
    let allGarageServices = this.props.vendorProfileReducer && this.props.vendorProfileReducer.allGarageServices;
    let carWash = filter(allServices, function (service) {
      return service.serviceParentId == 4;
    });
    const carWashListView = allGarageServices && map(carWash, (carItem, key) => {
      let servicePrice = find(allGarageServices, { 'serviceId': carItem.serviceId });
      return (
        <OverlayTrigger key={key} trigger="click" rootClose placement={this.state.popoverPosition} overlay={this.customPopoverWash()}>
          <div className="carModelList" onClick={() => { this.setState({ 'activeCarWash': carItem.id, popoverDesc: { name: carItem.name, desc: carItem.description, servicePrice: servicePrice } }); }}>
            <div className={carItem.id == this.state.activeCarWash ? 'img-circle active' : 'img-circle'}>
              <img src={carItem.image ? carItem.image : `${imageBasePath}/placeholder.png`} alt="" />
            </div>
            <h6>{carItem.name}</h6>
          </div>
        </OverlayTrigger>
      );
    });
    return (
      <div className="vendor-service-container">
        <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
          <div className="vendor-service-list">
            {size(carWashListView)
              ?
              carWashListView :
              <div className="noResults-found">
                <img src={`${imageBasePath}/empty_service.png`} />
                <p>Oops! We couldn’t find what you were looking for</p>
              </div>}
          </div>
        </CustomScroll>
      </div>
    );
  }
  selectTab(type) {
    if (type == this.state.serviceTab) {
      this.setState({ serviceTab: "" })
    } else {
      this.setState({ serviceTab: type })
    }
  }
  render() {
    return (
      <div className="vendor-services" id={this.props.isMobile ? "n-services-mobile" : "n-services"}>
        <div className="vendor-description">
          <h4>Services</h4>
          <Tabs defaultActiveKey={1} id="vendorServices_tab" className="vendorServices_tab_mobile">
            <Tab eventKey={1} title="Car Wash">
              {this.renderCarWash()}
            </Tab>
            <Tab eventKey={2} title="Car Repair">
              {this.renderCarRepair()}
            </Tab>
            <Tab eventKey={3} title="Car Service">
              {this.renderCarService()}
            </Tab>
            <Tab eventKey={4} title="Supported Manufacturers">
              {this.renderSupportedManufacturers()}
            </Tab>
            <Tab eventKey={5} title="Roadside Assistance">
              {this.renderEmergency()}
            </Tab>
          </Tabs>
          <PanelGroup defaultActiveKey="2" accordion id="vendorServices_panel">
            <ServiceTabs title="CAR WASH" renderView={this.renderCarWash()} open={this.state.serviceTab == "wash" ? true : false} tabClick={() => this.selectTab("wash")} />
            <ServiceTabs title="CAR REPAIR" renderView={this.renderCarRepair()} open={this.state.serviceTab == "repair" ? true : false} tabClick={() => this.selectTab("repair")} />
            <ServiceTabs title="CAR SERVICE" renderView={this.renderCarService()} open={this.state.serviceTab == "service" ? true : false} tabClick={() => this.selectTab("service")} />
            <ServiceTabs title="SUPPORTED MANUFACTURES" renderView={this.renderSupportedManufacturers()} open={this.state.serviceTab == "manufactures" ? true : false} tabClick={() => this.selectTab("manufactures")} />
            <ServiceTabs title="ROADSIDE ASSISTANCE" renderView={this.renderEmergency()} open={this.state.serviceTab == "emergency" ? true : false} tabClick={() => this.selectTab("emergency")} />
          </PanelGroup>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VendorProfile/Services.jsx